module Omni.ResortMap {
    ngModule.directive('partialSlideshow', ['$document',
        function ($document) {
            return {
                restrict: 'A',
                priority: 1001,
                link: function (scope, element, attrs) {


                }
            };
        }]);
}
